import { ITeams, TeamsActions } from "./types";
import { TeamsAction } from "./actions";

const defaultState: ITeams = {
    contacts: [],
    isTeamsContactsLoading: undefined,
    contactsStatuses: {},
    isTeamsStatusesLoading: undefined,
    errors: [],
};

const teamsReducer = (state = defaultState, action: TeamsAction) => {
    switch (action.type) {
        case TeamsActions.GET_TEAMS_CONTACTS:
            return { ...state, isTeamsContactsLoading: false, contacts: action.payload };

        case TeamsActions.TEAMS_CONTACTS_LOADING:
            return { ...state, isTeamsContactsLoading: action.payload };

        case TeamsActions.GET_TEAMS_STATUSES:
            return {
                ...state,
                isTeamsStatusesLoading: false,
                contactsStatuses: action.payload,
            };

        case TeamsActions.TEAMS_STATUSES_LOADING:
            return {
                ...state,
                isTeamsStatusesLoading: action.payload,
            };

        case TeamsActions.TEAMS_ERROR:
            return {
                ...state,
                errors: [...state.errors, action.payload],
            };

        default:
            return state;
    }
};

export default teamsReducer;
